import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { AlwaysShowRouteResolver } from '../shared/navigation/always-show-route-resolver';
export class PaymentsRouteDefinition {
  public static getRoutes(
    hasPaymentProcessorEnabled: boolean,
    hasPaymentTerminalEnabled: boolean,
    hasPaymentProcessingEnabled: boolean,
    canSeeReports: boolean
  ): RouteDefinition {
    const menuItems: RouteDefinition = {
      path: RoutePaths.PAYMENTS,
      resolver: AlwaysShowRouteResolver,
      title: 'Payments',
      icon: 'icon-payments.svg',
      position: 9,
      children: [
        {
          path: RoutePaths.TYPES,
          parentPath: RoutePaths.PAYMENTS,
          title: 'Payment Types',
          position: 1
        }
      ]
    };

    if (hasPaymentProcessorEnabled) {
      menuItems.children.push({
        path: RoutePaths.PROCESSORS,
        parentPath: RoutePaths.PAYMENTS,
        title: 'Payment Processors',
        position: 2
      });
    }
    if (hasPaymentTerminalEnabled) {
      menuItems.children.push({
        path: RoutePaths.TERMINALS,
        parentPath: RoutePaths.PAYMENTS,
        title: 'Payment Terminals',
        position: 3
      });
    }
    if (hasPaymentProcessingEnabled) {
      menuItems.children.push({
        path: RoutePaths.PROCESSING,
        parentPath: RoutePaths.PAYMENTS,
        title: 'Payment Processing',
        position: 4
      });
    }
    if (canSeeReports) {
      menuItems.children.push({
        path: RoutePaths.GIFTCARDS,
        parentPath: RoutePaths.PAYMENTS,
        title: 'Gift Cards',
        position: 5
      });
      menuItems.children.push({
        path: RoutePaths.GIFTCARDS_TRANSACTIONS,
        parentPath: RoutePaths.PAYMENTS,
        title: 'Gift Card Transactions',
        position: 6
      });
    }
    return menuItems;
  }
}
